import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router";
import LoadingWrapper from "../common/loading-wrapper";
import { Table } from "antd";
import { getTopLawFirmsByLPIX } from "../../services/api-prosecution";
import { sorterNumberGen } from "../../helpers/table";
import { isEqual } from "lodash";

class TopTable extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    filter: PropTypes.object,
    topSize: PropTypes.number.isRequired
  };

  state = {
    data: [],
    loading: true,
    error: false
  };

  componentDidMount() {
    this._isMounted = true;
    this._updateTable(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps, this.props)) {
      if (this._isMounted) this._updateTable(nextProps);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { loading, error, data } = this.state;
    const { title, style } = this.props;
    const columns = [
      {
        dataIndex: "key",
        title: title,
        render: val => <Link to={`/prosecution/lawfirm/${val}`}>{val}</Link>
      },
      {
        dataIndex: "count",
        title: "#Apps",
        sorter: sorterNumberGen("count")
      },
      {
        dataIndex: "lpix",
        title: "LPIX",
        sorter: sorterNumberGen("lpix"),
        render: val => (val * 100).toFixed(1) + "%"
      },
      {
        dataIndex: "rank",
        title: "Rank"
      }
    ];
    return (
      <LoadingWrapper loading={loading} error={error} style={style}>
        <Table dataSource={data} columns={columns} rowKey={"key"} pagination={false} size="small" />
      </LoadingWrapper>
    );
  }

  _updateTable = props =>
    getTopLawFirmsByLPIX(props.topSize, props.filter)
      .then(json => {
        if (this._isMounted) {
          this.setState({
            data: json,
            loading: false
          });
        }
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({
            loading: false,
            error: true
          });
        }
      });
}

export default withRouter(TopTable);
